module.exports = __webpack_public_path__ + "img/product27-chumo.54124b98.svg";